export const apiName: string = 'estados';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/estados/shared/data.service.ts
 **/